import ImportConnectorsTable from "./components/ImportConnectorsTable.jsx";

export default function ImportConnectorPage() {
  return <ImportConnectorsTable />;
}
